// Models
import { AlertsActionTypes, AlertDetails } from 'app/modules/alerts/models';
import {
  AlertActionEventResponse,
  GetAlertsListResponse,
  ShortAlertsCachedResponse,
} from 'app/modules/alerts/types/responses';

// Types
import {
  AssociatedEntitiesResponse,
  ShortAlertResponse,
} from 'app/modules/alerts/types';

// Utils
import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';
import { GetActionEventsPayload } from 'app/modules/actionEvents/requests';
import {
  AlertEditPayload,
  ChangeAlertStatusPayload,
  CreateAlertPayload,
  RetrieveAlertEntitiesPayload,
  RetrieveAlertTxnsPayload,
} from 'app/modules/alerts/requests';

export const createAlert = (payload: CreateAlertPayload) =>
  createAction(AlertsActionTypes.CREATE_ALERT, payload);

export const createAlertSuccess = (result: AlertDetails) =>
  createAction(AlertsActionTypes.CREATE_ALERT_SUCCESS, result);

export const editAlert = (payload: AlertEditPayload) =>
  createAction(AlertsActionTypes.EDIT_ALERT, payload);

export const editAlertSuccess = (result: ShortAlertResponse) =>
  createAction(AlertsActionTypes.EDIT_ALERT_SUCCESS, result);

export const retrieveAlertsSuccess = (
  result: ShortAlertsCachedResponse | GetAlertsListResponse,
) => createAction(AlertsActionTypes.RETRIEVE_ALERTS_SUCCESS, result);

export const retrieveAlert = (payload: {
  id: number;
  useAlertTxnCacheEndpoint: boolean;
}) => createAction(AlertsActionTypes.RETRIEVE_ALERT, payload);

export const retrieveAlertSuccess = (result) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_SUCCESS, result);

export const retrieveAlertDetailsSuccess = (result) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_DETAILS_SUCCESS, result);

export const retrieveAlertTransactions = (payload: RetrieveAlertTxnsPayload) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_TRANSACTIONS, payload);

export const retrieveAlertTransactionsSuccess = (result) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_TRANSACTIONS_SUCCESS, result);

export const retrieveAlertEntities = (payload: RetrieveAlertEntitiesPayload) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_ENTITIES, payload);

export const retrieveAlertEntitiesSuccess = (
  result: AssociatedEntitiesResponse,
) => {
  return createAction(
    AlertsActionTypes.RETRIEVE_ALERT_ENTITIES_SUCCESS,
    result,
  );
};

export const addDocumentsSuccess = (result) =>
  createAction(AlertsActionTypes.ADD_DOCUMENTS_SUCCESS, result);

export const changeAlertComponentStatus = (
  payload: ChangeAlertStatusPayload,
  onSuccess?: {
    txnUpdate?: RetrieveAlertTxnsPayload;
    entityUpdate?: RetrieveAlertEntitiesPayload;
  },
) => {
  return createAction(
    AlertsActionTypes.CHANGE_ALERT_COMPONENT_STATUS,
    payload,
    onSuccess,
  );
};

export const changeAlertComponentStatusSuccess = (result) =>
  createAction(AlertsActionTypes.CHANGE_ALERT_COMPONENT_STATUS_SUCCESS, result);

export const deleteDocumentSuccess = (result) =>
  createAction(AlertsActionTypes.DELETE_DOCUMENT_SUCCESS, result);

export const clearAlertEntities = () =>
  createAction(AlertsActionTypes.CLEAR_ALERT_ENTITIES);

export const retrieveAlertActionEvents = (payload: GetActionEventsPayload) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_ACTION_EVENTS, payload);
export const retrieveAlertActionEventsSuccess = (
  result: AlertActionEventResponse,
) =>
  createAction(AlertsActionTypes.RETRIEVE_ALERT_ACTION_EVENTS_SUCCESS, result);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AlertsActionsList = {
  retrieveAlertsSuccess,
  retrieveAlertSuccess,
  retrieveAlertDetailsSuccess,
  retrieveAlertTransactionsSuccess,
  retrieveAlertEntitiesSuccess,
  changeAlertComponentStatusSuccess,
  createAlertSuccess,
  editAlertSuccess,
  addDocumentsSuccess,
  deleteDocumentSuccess,
  clearAlertEntities,
  retrieveAlertActionEventsSuccess,
};

export type AlertsActions = ActionsUnion<typeof AlertsActionsList>;
